import { UPDATE_ROTATIONSPLAN_VORLAGE } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useUpdateRotationsplanVorlage/mutation';
import {
  Mitarbeiter_UpdateRotationsplanVorlageMutation,
  Mitarbeiter_UpdateRotationsplanVorlageMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateRotationsplanVorlage() {
  const [execute, result] = useMutation<
    Mitarbeiter_UpdateRotationsplanVorlageMutation,
    Mitarbeiter_UpdateRotationsplanVorlageMutationVariables
  >(UPDATE_ROTATIONSPLAN_VORLAGE, {
    refetchQueries: [
      'mitarbeiter_rotationsplanVorlagen',
      'mitarbeiter_rotationsplanVorlageById',
    ],
    awaitRefetchQueries: true,
  });

  const updateRotationsplanVorlage = useCallback(
    (variables: Mitarbeiter_UpdateRotationsplanVorlageMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [updateRotationsplanVorlage, result] as const;
}
